var map = {
	"./action.svg": 207,
	"./adventure.svg": 208,
	"./advertorial.svg": 209,
	"./ai.svg": 210,
	"./album.svg": 211,
	"./analysis.svg": 212,
	"./anchor.svg": 213,
	"./android-block.svg": 214,
	"./android-small.svg": 215,
	"./android.svg": 216,
	"./angle-down.svg": 217,
	"./angle-left.svg": 218,
	"./angle-right.svg": 219,
	"./angle-up.svg": 220,
	"./aquarius.svg": 221,
	"./arcade.svg": 222,
	"./aries.svg": 223,
	"./arrow-down.svg": 224,
	"./arrow-left.svg": 225,
	"./arrow-right.svg": 226,
	"./arrow-up.svg": 227,
	"./arrow.svg": 228,
	"./art-director.svg": 229,
	"./astrology.svg": 230,
	"./author-avator.svg": 231,
	"./author.svg": 232,
	"./authoranchor.svg": 233,
	"./authorwhite.svg": 234,
	"./automobile.svg": 235,
	"./backward.svg": 236,
	"./bookmark.svg": 237,
	"./books-vikatan.svg": 238,
	"./brandconnect.svg": 239,
	"./breaking-news.svg": 240,
	"./bullet-arrow.svg": 241,
	"./bundle.svg": 242,
	"./business.svg": 243,
	"./calendar.svg": 244,
	"./cancel.svg": 245,
	"./cancer.svg": 246,
	"./canvas.svg": 247,
	"./capricorn.svg": 248,
	"./cartoonist.svg": 249,
	"./cinema.svg": 250,
	"./clapboard.svg": 251,
	"./clipboard.svg": 252,
	"./close.svg": 253,
	"./comment.svg": 254,
	"./corona-updates-icon.svg": 255,
	"./creative-director.svg": 256,
	"./cricket.svg": 257,
	"./crime.svg": 258,
	"./data.svg": 259,
	"./designed.svg": 260,
	"./double-arrow.svg": 261,
	"./downarrow.svg": 262,
	"./download.svg": 263,
	"./edit.svg": 264,
	"./edited-by.svg": 265,
	"./email.svg": 266,
	"./environment.svg": 267,
	"./exclusivedeals.svg": 268,
	"./facebook-bg.svg": 269,
	"./facebook-icon.svg": 270,
	"./facebook.svg": 271,
	"./filter-icon.svg": 272,
	"./filter.svg": 273,
	"./food-stylist.svg": 274,
	"./forward.svg": 275,
	"./gallery.svg": 276,
	"./game-shop.svg": 277,
	"./gemini.svg": 278,
	"./group.svg": 279,
	"./gzhome.svg": 280,
	"./gzsports.svg": 281,
	"./gztrending.svg": 282,
	"./health.svg": 283,
	"./hexbackground.svg": 284,
	"./home.svg": 285,
	"./humoursatire-entertainment.svg": 286,
	"./icon-apple.svg": 287,
	"./icon-appstore.svg": 288,
	"./icon-audio-app-store.svg": 289,
	"./icon-audio-fb.svg": 290,
	"./icon-audio-instagram.svg": 291,
	"./icon-audio-next.svg": 292,
	"./icon-audio-play-store.svg": 293,
	"./icon-audio-previous.svg": 294,
	"./icon-audio-twitter.svg": 295,
	"./icon-audio-whatsapp.svg": 296,
	"./icon-copy.svg": 297,
	"./icon-episode.svg": 298,
	"./icon-facebook.svg": 299,
	"./icon-google-play.svg": 300,
	"./icon-headset.svg": 301,
	"./icon-home-plus.svg": 302,
	"./icon-login.svg": 303,
	"./icon-open-in-new.svg": 304,
	"./icon-pause.svg": 305,
	"./icon-play.svg": 306,
	"./icon-playstore.svg": 307,
	"./icon-premium.svg": 308,
	"./icon-share.svg": 309,
	"./icon-star.svg": 310,
	"./icon-timer.svg": 311,
	"./icon-twitter.svg": 312,
	"./icon-user.svg": 313,
	"./icon-video.svg": 314,
	"./icon-whatsapp.svg": 315,
	"./illustrator-t1.svg": 316,
	"./illustrator.svg": 317,
	"./infographer.svg": 318,
	"./instagram.svg": 319,
	"./interviews.svg": 320,
	"./ios-block.svg": 321,
	"./ios-small.svg": 322,
	"./ios.svg": 323,
	"./jokes.svg": 324,
	"./leo.svg": 325,
	"./libra.svg": 326,
	"./lifestyle.svg": 327,
	"./line-arrow-next.svg": 328,
	"./line-arrow-prev.svg": 329,
	"./linkedin.svg": 330,
	"./listicle.svg": 331,
	"./live-chat.svg": 332,
	"./liveupdate.svg": 333,
	"./log green.svg": 334,
	"./log grey.svg": 335,
	"./log white.svg": 336,
	"./logic.svg": 337,
	"./login-facebook.svg": 338,
	"./login-google.svg": 339,
	"./login.svg": 340,
	"./logout-mobile.svg": 341,
	"./logout.svg": 342,
	"./longform.svg": 343,
	"./magazines.svg": 344,
	"./mail.svg": 345,
	"./menu-search.svg": 346,
	"./microphone.svg": 347,
	"./minus.svg": 348,
	"./mobile-share.svg": 349,
	"./moderated.svg": 350,
	"./more-outline.svg": 351,
	"./my-vikatan-logo.svg": 352,
	"./mynews.svg": 353,
	"./myvikatanbadge.svg": 354,
	"./narrated.svg": 355,
	"./news.svg": 356,
	"./newsletter.svg": 357,
	"./newslettericon.svg": 358,
	"./olympic.svg": 359,
	"./online-news.svg": 360,
	"./pause.svg": 361,
	"./pdf.svg": 362,
	"./pen.svg": 363,
	"./personalise.svg": 364,
	"./phone.svg": 365,
	"./photo.svg": 366,
	"./photographer.svg": 367,
	"./photostory.svg": 368,
	"./pisces.svg": 369,
	"./play.svg": 370,
	"./plus.svg": 371,
	"./podcast.svg": 372,
	"./podcast_vikatan_menu.svg": 373,
	"./poems.svg": 374,
	"./politics.svg": 375,
	"./premium.svg": 376,
	"./producer.svg": 377,
	"./proofread.svg": 378,
	"./published-by.svg": 379,
	"./published.svg": 380,
	"./rain.svg": 381,
	"./rss.svg": 382,
	"./rupee.svg": 383,
	"./sagitarius.svg": 384,
	"./scorpio.svg": 385,
	"./script-writer.svg": 386,
	"./scripted.svg": 387,
	"./search.svg": 388,
	"./share-alt.svg": 389,
	"./share.svg": 390,
	"./sharechat.svg": 391,
	"./shortform.svg": 392,
	"./shortstories.svg": 393,
	"./shortvideo.svg": 394,
	"./slider-next.svg": 395,
	"./slider-prev.svg": 396,
	"./socialshare.svg": 397,
	"./sort.svg": 398,
	"./sound.svg": 399,
	"./speaker.svg": 400,
	"./speakeraudio.svg": 401,
	"./spiritual.svg": 402,
	"./sponsored.svg": 403,
	"./sports.svg": 404,
	"./star.svg": 405,
	"./stories.svg": 406,
	"./strategy.svg": 407,
	"./stylist.svg": 408,
	"./subscribe-vikatan.svg": 409,
	"./success-icon.svg": 410,
	"./tag.svg": 411,
	"./taurus.svg": 412,
	"./technology.svg": 413,
	"./text.svg": 414,
	"./textsms.svg": 415,
	"./thodargal.svg": 416,
	"./thump.svg": 417,
	"./tick.svg": 418,
	"./trending.svg": 419,
	"./twitter-icon.svg": 420,
	"./twitter.svg": 421,
	"./uparrow.svg": 422,
	"./update-black.svg": 423,
	"./user-square.svg": 424,
	"./user.svg": 425,
	"./v-plus-logo.svg": 426,
	"./video-editor.svg": 427,
	"./video-icon.svg": 428,
	"./video-play.svg": 429,
	"./video.svg": 430,
	"./videographer.svg": 431,
	"./vikatan-play-logo-red.svg": 432,
	"./vikatan-play.svg": 433,
	"./vikatan-tv.svg": 434,
	"./vikatan.svg": 435,
	"./vikatanconnect.svg": 436,
	"./vikatanplay.svg": 437,
	"./vikatanspl.svg": 438,
	"./vikatantv.svg": 439,
	"./virgo.svg": 440,
	"./whatsapp-icon.svg": 441,
	"./whatsapp-icon1.svg": 442,
	"./whatsapp.svg": 443,
	"./women-home.svg": 444,
	"./writtenarticles.svg": 445,
	"./writtenstory.svg": 446,
	"./youtube.svg": 447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;